import { render, staticRenderFns } from "./ResourceTypeSwitchField.vue?vue&type=template&id=95832970&lang=pug&"
import script from "./ResourceTypeSwitchField.vue?vue&type=script&lang=js&"
export * from "./ResourceTypeSwitchField.vue?vue&type=script&lang=js&"
import style0 from "./ResourceTypeSwitchField.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports